import { FormState } from '@vtex/admin-ui-form'
import toIso2 from 'country-iso-3-to-2'
import { useShippingCountries } from 'hooks'
import { useIntl } from 'react-intl'
import { Item } from 'typings'
import { MultiSelect } from '../../MultiSelect'

type ShippingCoutriesSelectorProps = {
  name: string
  state: FormState
}

export function ShippingCoutriesSelector(props: ShippingCoutriesSelectorProps) {
  const { name, state } = props
  const { $t, formatDisplayName } = useIntl()

  const { data: options, isLoading } = useShippingCountries()

  const availableShippingCountries: Item[] =
    options?.map((countryCode) => ({
      id: countryCode,
      name:
        formatDisplayName(toIso2(countryCode), { type: 'region' }) ??
        countryCode,
    })) ?? []

  return (
    <MultiSelect
      name={name}
      state={state}
      options={availableShippingCountries}
      label={$t({
        id: 'admin/promotions.form.conditions.shipping-countries.select.placeholder',
      })}
      loadingOptions={isLoading}
      maxEntries={50}
    />
  )
}
